import React, { FunctionComponent } from "react";

import { LiteListFrameGeneralAttribute } from "../../../components/LiteListFrameGeneralAttribute";
import { CanRenderEmptyDecider, FrameAttributeSharedProps } from "../../../types";
import { defaultCanRenderEmpty } from "../../../utils";
import { LiteListFrameLOVAttribute } from "./attribute";

export type LiteListFrameLOVAttributeComponentProps = FrameAttributeSharedProps;

const canRenderEmpty: CanRenderEmptyDecider = (record, info) => {
    const defaultResult = defaultCanRenderEmpty(record, info);
    const newResult = record[info.attributeName]?.value == "0";

    return defaultResult || newResult;
};

export const LiteListFrameLOVAttributeComponent: FunctionComponent<LiteListFrameLOVAttributeComponentProps> = (
    props,
) => (
    <LiteListFrameGeneralAttribute
        {...props}
        canRenderEmpty={canRenderEmpty}
        AttributeComponent={LiteListFrameLOVAttribute}
        hasBackgroundAttr={false}
    />
);
